<template>  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-user icon--full-color"
  >
    <path
      d="M23 24V21.6667C23 20.429 22.4996 19.242 21.6088 18.3668C20.718 17.4917 19.5098 17 18.25 17H8.75C7.49022 17 6.28204 17.4917 5.39124 18.3668C4.50044 19.242 4 20.429 4 21.6667V24M18.25 7.66667C18.25 10.244 16.1234 12.3333 13.5 12.3333C10.8766 12.3333 8.75 10.244 8.75 7.66667C8.75 5.08934 10.8766 3 13.5 3C16.1234 3 18.25 5.08934 18.25 7.66667Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></template>